export const PAYMENT_GATEWAY_FATZEBRA = "fatzebra";

// Post-launch, all Gatsby card flows use Fat Zebra regardless of CMS flags.
export const resolveDonationPaymentGateway = () => PAYMENT_GATEWAY_FATZEBRA;

export const resolveRenewPaymentGateway = () => PAYMENT_GATEWAY_FATZEBRA;

export const isFatZebraGateway = (paymentGateway) => paymentGateway === PAYMENT_GATEWAY_FATZEBRA;
